import { generateAsyncSagaWatcher } from '../../../utils';
import { ECareersActions } from './enums';
import { ICareer } from './models';

export const careersSaga = generateAsyncSagaWatcher<ICareer>(ECareersActions.GET_CAREERS);

export const applyPositionSaga = generateAsyncSagaWatcher<void>(ECareersActions.APPLY_POSITION);
